import { render, staticRenderFns } from "./CoursewareTasksActionWidget.vue?vue&type=template&id=4c74c71f&scoped=true&"
import script from "./CoursewareTasksActionWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareTasksActionWidget.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareTasksActionWidget.vue?vue&type=style&index=0&id=4c74c71f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74c71f",
  null
  
)

export default component.exports